import { Button, Flex, Typography } from "antd"
import { useTranslation } from "react-i18next"

import Icon from "../../Icon"

import "./styles.less"

const { Text } = Typography

export const BannerAnotherProvider = ({ handleCloseProviderBanner }) => {
  const { t } = useTranslation()

  return (
    <Flex
      className="demo-mode-banner another_provider"
      gap={8}
      align="center"
      justify="space-between"
    >
      <div />
      <Flex gap={8} align="center">
        <Icon className="triangle-error-icon" type={"info_banner"} />
        <p className="text">
          <Text className="content" type="secondary">
            {t("To switch, please review the")}{" "}
            <a
              href="https://help.chargeback.io/en/articles/12782794-managing-provider-transfers-for-chargeback-io"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("provider transfer instructions")}
            </a>{" "}
            {t("to activate")}{" "}
            <a href="https://help.chargeback.io" target="_blank" rel="noopener noreferrer">
              chargeback.io.
            </a>
          </Text>
        </p>
      </Flex>
      <Button
        type="text"
        className="close-icon"
        icon={<Icon type="close_modal" />}
        onClick={handleCloseProviderBanner}
      />
    </Flex>
  )
}

export default BannerAnotherProvider
